import styled from 'styled-components/macro'
import { Overlay } from 'styles/misc'
import { mq } from 'styles/mq'

export const Header = styled.header`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - var(--mobile-menu-button-height));
  height: calc(100svh - var(--mobile-menu-button-height));
  max-height: 100vh;
  padding: calc(var(--header-height) + 2rem) 2rem 2rem;
  overflow: hidden;
  color: white;
  background-color: #1f2124;

  &::before {
    content: '';
    display: block;
    flex: 3;

    ${mq.medium} {
      flex: 1;
    }
  }

  &::after {
    content: '';
    display: block;
    ${Overlay}
    background-color: var(--text-color);
    opacity: 0.6;
  }

  ${mq.medium} {
    height: auto;
    padding: 3rem;
    aspect-ratio: 16 / 9;
  }
`

export const Arrow = styled.div`
  &,
  span {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
  }

  span {
    flex: 10;

    &::before,
    &::after {
      content: '';
      display: block;
      z-index: 1;
    }

    &::before {
      content: '';
      display: block;
      flex: 1;
      border-left: 2px solid currentColor;
    }

    &::after {
      content: '';
      display: block;
      width: 2rem;
      height: 2rem;
      margin-top: -2.2rem;
      border-left: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      flex-shrink: 0;
      transform: rotateZ(-45deg);
    }
  }

  &::before,
  &::after {
    content: '';
    display: block;
    flex: 1;
  }
`

export const Title = styled.h1`
  position: relative;
  margin: 0;
  font-size: clamp(2rem, 10vw, 7rem);
  text-align: center;
  font-weight: normal;
  max-width: 15em;
  z-index: 1;

  strong {
    font-weight: 800;
  }
`

export const ImageTile = styled.div<{ image: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem;
  aspect-ratio: 16 / 9;
  color: white;
  font-size: 1.4rem;
  background: linear-gradient(-287deg, #0a0f18 0%, rgba(10, 11, 13, 0) 80%),
    url(${props => props.image}) center center/cover;

  h2 {
    margin: 0;
    font-size: clamp(2rem, 3.4vw, 6rem);
    font-weight: 800;
  }

  > div {
    max-width: 25em;
  }

  ${mq.smallOnly} {
    margin: 0 calc(var(--container-spacing) * -1);
    width: calc(100% + 2 * var(--container-spacing));
    min-height: calc(100svh - 10rem);
  }

  ${mq.medium} {
    padding: 4rem 6rem;
    font-size: 1.6rem;
  }

  ${mq.large} {
    padding: 6rem 10rem;
    font-size: 1.8rem;
  }
`

export const Chapter = styled.div`
  counter-reset: section-counter;
`
